// todo: fill in missing colours
export default {
    primary: {
        light: '#6c7378',
        main: '#415667',
        dark: '#4e5c67',
        text: '#fff'
    },
    secondary: {
        light: '#1981c4',
        main: '#1576b4',
        text: '#fff'
    },
    tertiary: {
    // todo: do we want this?
        light: '#e4eaef',
        main: '#adb6bc',
        dark: '#6c7378',
        text: '#484848'
    },
    success: {
        light: '#5cb85c',
        main: '#5cb85c',
        text: '#fff'
    },
    error: {
        light: '#bf2c30',
        main: '#c53902',
        text: '#fff'
    }
};



// WEBPACK FOOTER //
// ./app/themes/default-theme/palette.js